import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-36d882f7"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "volume-adjuster"
};
var _hoisted_2 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_volume_progress = _resolveComponent("volume-progress");

  var _component_el_popover = _resolveComponent("el-popover");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_popover, {
    placement: "top",
    trigger: "hover",
    style: {
      width: '30px'
    },
    "popper-class": "volume-popover",
    onShow: _ctx.showPopover,
    onHide: _ctx.hidePopover
  }, {
    reference: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "content", {}, undefined, true)];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_volume_progress, {
        visible: _ctx.visible,
        percentage: _ctx.volume,
        onChangeProgress: _ctx.onChangeProgress
      }, null, 8
      /* PROPS */
      , ["visible", "percentage", "onChangeProgress"])])];
    }),
    _: 3
    /* FORWARDED */

  }, 8
  /* PROPS */
  , ["onShow", "onHide"])]);
}